import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

const PasswordResetPage: React.FC = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const backendUrl =
    process.env.REACT_APP_BACKEND_URL || "http://localhost:3201";

  const token = searchParams.get("token");
  // Invited attorneys arrive here from their account email to choose a first password.
  const welcome = searchParams.get("welcome") === "1";

  const handlePasswordReset = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      await axios.post(`${backendUrl}/api/resetpassword`, {
        token,
        newPassword,
      });
      navigate("/login");
    } catch (error: any) {
      setError(
        error?.response?.status === 400 && error.response.data?.message
          ? error.response.data.message
          : "We couldn’t reset your password. Please try again or request a new reset link."
      );
      console.error(error);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="mb-4">
          {welcome
            ? "Set your Reviewed password"
            : "Reset your Reviewed password"}
        </h1>
        {welcome && (
          <p className="text-secondary">
            Welcome to Reviewed. Choose a password, then sign in with your email
            address.
          </p>
        )}
        {error && <div className="alert alert-danger">{error}</div>}
        <form onSubmit={handlePasswordReset}>
          <div className="mb-3">
            <label htmlFor="new-password" className="form-label">
              New password
            </label>
            <input
              type="password"
              className="form-control"
              id="new-password"
              value={newPassword}
              onChange={event => setNewPassword(event.target.value)}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="confirm-password" className="form-label">
              Confirm new password
            </label>
            <input
              type="password"
              className="form-control"
              id="confirm-password"
              value={confirmPassword}
              onChange={event => setConfirmPassword(event.target.value)}
            />
          </div>
          <button type="submit" className="btn btn-primary mb-3">
            {welcome ? "Set password" : "Reset password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordResetPage;
